import iconArrow from 'assets/image/icons/tables/arrow-rigth.svg'
import inIcon from 'assets/image/icons/tables/linkedin-icon-gray.svg'
import iconMessage from 'assets/image/icons/tables/message.svg'
import { Link } from 'react-router-dom'

import { linkedInProfileOpener } from '../../../api/linkedInProfileOpener'
import TooltipCustom from '../../atoms/tooltipCustom'
import { Details } from './Info'

export function Actions({
	activities,
	index,
	item
}: { activities: any[]; index: number; item: any }) {
	const hasMany = activities.length > 6
	const isFirstChunk = index > activities.length - 3

	const openLinkedinProfile = () => linkedInProfileOpener.open(item)

	return (
		item.actions && (
			<div className='btn-group'>
				<Details isUpward={hasMany && isFirstChunk} item={item} />
				<TooltipCustom arrow title={item.actions.open_linkedin_profile.hint}>
					<button
						className={
							item.actions.open_linkedin_profile.enabled
								? 'btn-row info'
								: 'btn-row info disabled'
						}
						onClick={openLinkedinProfile}
					>
						<img alt='linkedin icon' src={inIcon} />
					</button>
				</TooltipCustom>
				<TooltipCustom arrow title={item.actions.open_conversation.hint}>
					{item.actions.open_conversation.enabled ? (
						<a
							className='btn-row info'
							href={item.conversation_url}
							rel='noopener noreferrer'
							target='_blank'
						>
							<img alt='messageIcon' src={iconMessage} />
						</a>
					) : (
						<button className='btn-row info disabled' disabled>
							<img alt='messageIcon' src={iconMessage} />
						</button>
					)}
				</TooltipCustom>
				<TooltipCustom arrow title={item.actions.open_campaign.hint}>
					{item.actions.open_campaign.enabled ? (
						<Link
							className='btn-row info'
							to={`/campaigns/${item.campaign_id}`}
						>
							<img alt='arrowIcon' src={iconArrow} />
						</Link>
					) : (
						<button className='btn-row info disabled' disabled>
							<img alt='arrowIcon' src={iconArrow} />
						</button>
					)}
				</TooltipCustom>
			</div>
		)
	)
}
